var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWifiHigh = function SvgIconWifiHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.252c-3.347 0-6.56 1.317-8.945 3.667a1 1 0 0 1-1.403-1.425 14.744 14.744 0 0 1 20.697 0 1 1 0 0 1-1.404 1.425A12.74 12.74 0 0 0 12 6.252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23 13.1a8.263 8.263 0 0 1 11.54 0 1 1 0 1 0 1.397-1.431 10.26 10.26 0 0 0-14.334 0A1 1 0 0 0 6.23 13.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.401 16.294a3.753 3.753 0 0 1 5.197 0 1 1 0 1 0 1.384-1.444 5.753 5.753 0 0 0-7.965 0A1 1 0 1 0 9.4 16.294M13.5 18.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconWifiHigh;